import styled from 'styled-components';
import colors from '@theme/colors';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 256px;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const LogoContainer = styled.div`
  padding: 50px 0 50px 0;
  text-align: center;
`;

export const UtilityPanel = styled.div`
  margin: 0 auto;
  padding: 50px;
  max-width: 800px;
  background-color: ${colors.WHITE};
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./components/layout/UtilityPage.js